var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF2C5C"
    },
    d: "M508,496.547H4c-2.209,0-4-1.791-4-4V129.682c0-2.209,1.791-4,4-4h504c2.209,0,4,1.791,4,4v362.865   C512,494.756,510.209,496.547,508,496.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62753"
    },
    d: "M481.095,129.682v362.865c0,2.209,1.791,4,4,4H508c2.209,0,4-1.791,4-4V129.682c0-2.209-1.791-4-4-4   h-22.905C482.885,125.682,481.095,127.473,481.095,129.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6244D"
    },
    d: "M271.453,463.581v32.966c0,8.53-6.923,15.453-15.453,15.453c-8.53,0-15.453-6.923-15.453-15.453   v-32.966H271.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEBADE"
    },
    d: "M256,463.581H33.36c-2.209,0-4-1.791-4-4V417c0-2.209,1.791-4,4-4H256V463.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B1D4"
    },
    d: "M478.64,463.581H256V413h222.64c2.209,0,4,1.791,4,4v42.581   C482.64,461.791,480.849,463.581,478.64,463.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D5ED"
    },
    d: "M256,432.676H33.36c-2.209,0-4-1.791-4-4V102.897c0-2.209,1.791-4,4-4H256V432.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7C3E3"
    },
    d: "M478.64,432.676H256V98.897h222.64c2.209,0,4,1.791,4,4v325.779   C482.64,430.885,480.849,432.676,478.64,432.676z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M302.358,284.104h19.926c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-19.926    c-4.143,0-7.5,3.358-7.5,7.5S298.216,284.104,302.358,284.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M302.358,320.503h133.923c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H302.358    c-4.143,0-7.5,3.358-7.5,7.5S298.216,320.503,302.358,320.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M436.281,341.903H302.358c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h133.923    c4.143,0,7.5-3.358,7.5-7.5S440.424,341.903,436.281,341.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M349.857,378.303h-47.499c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h47.499    c4.143,0,7.5-3.358,7.5-7.5S354,378.303,349.857,378.303z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD659"
    },
    d: "M374.038,325.167c-33.509-41.74-17.288-62.105-17.288-62.105l43.517,0    c0,0,16.234,20.365-17.287,62.105C380.719,327.983,376.299,327.983,374.038,325.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M378.511,257.691c-4.143,0-7.5,3.358-7.5,7.5v20c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-20    C386.011,261.049,382.653,257.691,378.511,257.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD659"
    },
    d: "M404.369,265.468l-51.716,0c-2.787,0-5.047-2.26-5.047-5.047l-0.001-245.484    c0-8.25,6.688-14.937,14.937-14.937l31.935,0c8.25,0,14.937,6.688,14.937,14.937l0.001,245.484    C409.416,263.209,407.156,265.468,404.369,265.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD54"
    },
    d: "M394.477,0l-30.905,0c8.25,0,14.937,6.688,14.937,14.937l0.001,245.484    c0,2.787-2.259,5.047-5.047,5.047l30.905,0c2.787,0,5.047-2.26,5.047-5.047l-0.001-245.484C409.414,6.688,402.727,0,394.477,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5FCFF"
    },
    d: "M404.369,265.468l-51.716,0c-2.787,0-5.047-2.26-5.047-5.047l0-25.858l61.81,0l0,25.858    C409.416,263.209,407.156,265.468,404.369,265.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CF2FF"
    },
    d: "M378.511,234.563l0,25.858c0,2.787-2.259,5.047-5.047,5.047l30.905,0    c2.787,0,5.047-2.26,5.047-5.047l0-25.858L378.511,234.563z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.605,
    y: 48.099,
    style: {
      fill: "#B5FCFF"
    },
    width: 61.81,
    height: 30.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.51,
    y: 48.099,
    style: {
      fill: "#8CF2FF"
    },
    width: 30.905,
    height: 30.905
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M142.68,367.26L142.68,367.26c-8.534,0-15.453-6.918-15.453-15.453V208.612h30.905v143.195   C158.133,360.341,151.214,367.26,142.68,367.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5FCFF"
    },
    d: "M142.68,227.155c-45.444,0-82.414-36.971-82.414-82.414s36.971-82.414,82.414-82.414   s82.414,36.971,82.414,82.414S188.124,227.155,142.68,227.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71F6FC"
    },
    d: "M142.68,62.326c-5.283,0-10.444,0.52-15.453,1.474c38.08,7.256,66.962,40.78,66.962,80.941   s-28.882,73.685-66.962,80.941c5.009,0.954,10.17,1.474,15.453,1.474c45.444,0,82.414-36.971,82.414-82.414   C225.095,99.297,188.124,62.326,142.68,62.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M142.68,54.826c-49.579,0-89.914,40.335-89.914,89.914c0,49.579,40.335,89.915,89.914,89.915   s89.915-40.335,89.915-89.915C232.595,95.162,192.259,54.826,142.68,54.826z M142.68,219.655   c-41.308,0-74.914-33.606-74.914-74.915c0-41.308,33.606-74.914,74.914-74.914c41.309,0,74.915,33.606,74.915,74.914   C217.595,186.048,183.988,219.655,142.68,219.655z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooking);
export default __webpack_public_path__ + "static/media/icon_booking.f1bbcc40ac9d5c0c3912c45125de8ea5.svg";
export { ForwardRef as ReactComponent };